import { render } from "./ChecklistPerizia.vue?vue&type=template&id=69b3bc30&scoped=true"
import script from "./ChecklistPerizia.vue?vue&type=script&lang=js"
export * from "./ChecklistPerizia.vue?vue&type=script&lang=js"

import "./ChecklistPerizia.vue?vue&type=style&index=0&id=69b3bc30&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b3bc30"]])

export default __exports__